import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, takeWhile} from 'rxjs';

@Injectable({
  providedIn: 'any'
})
export class AuthHttpService {

  public token2FA="";

  constructor(private httpClient: HttpClient) {
    }

    createUser(userData: any): Observable<any> {
      return this.httpClient.post<any[]>('api/auth/v1/signup',userData)
    }

    login(email: string, password: string): Observable<any> {
      const payload = { email: email, password: password};
      return this.httpClient.post<any[]>('api/auth/v1/login',payload);
    }

    /*forgotPassword(email: string): Observable<any> {
      return this.httpClient.post<any>(`api/auth/v1/forgot-password`, {
        email,
      });
    }*/
  forgotPassword(email: string): Observable<any> {
    return this.httpClient.post<any>(`api/auth/v1/password/request`, {
      email,
    });
  }
  resetPassword(token: any , password: any ): Observable<any>{
    return  this.httpClient.post<any>(`api/auth/v1/password/reset`,{
      token,
      password
    })
  }

    logout(): Observable<any> {
      return this.httpClient.post<any>(`api/auth/v1/logout`, {});
    }

    checkUser(): Observable<any> {
      return this.httpClient.post<any>(`api/auth/v1/preparing`,'').pipe(takeWhile((response) => response.data?.is_ready !== true,true))
    }

    checkToken(): Observable<any> {
      return this.httpClient.post<any>(`api/auth/v1/checktoken`,'')
    }
    checkCode(code : string ):Observable<any>{
    return this.httpClient.post<any>('api/auth/v1/password/reset/validate',{
      code,
    })
    }
    userConnect():Observable<any>{
    return this.httpClient.get<any>('api/auth/v1/get/users/stats' )
    }
   getAsset() : Observable<any>{
    return this.httpClient.get<any>('api/asset/v1/get/user/assets')
   }

  //  start two factor authentication
  setEnable2FA():Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.token2FA
    });
    return this.httpClient.post('api/sso/user/two-factor-authentication',{},{headers:headers});
  }

  confirm2FA(payload:any):Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.token2FA
    });
    return this.httpClient.post('api/sso/user/confirmed-two-factor-authentication',payload,{headers:headers});
  }

  get2faQrCode():Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.token2FA
    });
    return this.httpClient.get('api/sso/user/two-factor-qr-code',{headers:headers});
  }

  get2faRecovryCodes():Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.token2FA
    });
    return this.httpClient.get('api/sso/user/two-factor-recovery-codes',{headers:headers});
  }

  confirm2faSessionCode(payload:any):Observable<any>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.token2FA
    });
    return this.httpClient.post('api/sso/two-factor-challenge',payload,{headers:headers})
  }
  // end two factor authentication
}
